import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import type { ActionMenuProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { ActionMenus } from './ActionMenus';
import type { ExportAdminInvoiceReportsProps } from './types';

const InnerExportAdminInvoiceReports: FC<ExportAdminInvoiceReportsProps> = memo(
  ({ isDisabled, onExport, isLoading }) => {
    const dropDownProps: ActionMenuProps['dropDownProps'] = useMemo(
      () => ({ destroyPopupOnHide: true }),
      []
    );

    return (
      <ActionMenus
        onExport={onExport}
        isDisabled={isDisabled}
        dropDownProps={dropDownProps}
        isLoading={isLoading}
      />
    );
  }
);

InnerExportAdminInvoiceReports.displayName = 'InnerExportAdminInvoiceReports';

export const ExportAdminInvoiceReports: FC<ExportAdminInvoiceReportsProps> =
  memo(({ isDisabled, onExport, isLoading }) => (
    <SuspenseErrorBoundary>
      <InnerExportAdminInvoiceReports
        isDisabled={isDisabled}
        onExport={onExport}
        isLoading={isLoading}
      />
    </SuspenseErrorBoundary>
  ));

ExportAdminInvoiceReports.displayName = 'ExportAdminInvoiceReports';
